import React, { useEffect, useState } from "react";
import moment from "moment-timezone";

const deviceTimeZone = () => moment.tz.guess();

const formatTime = (timeZone) => moment().tz(timeZone).format("hh:mm A");

// Shows a live clock, refreshed every second.
//
// Two distinct uses, so the fallback is opt-in rather than automatic:
//  - `deviceTime` - the learner looking at their own request, where the clock is
//    just the system time of the device they are on.
//  - `timeZone`   - the teacher / organization looking at someone else's request,
//    where the clock must be the learner's timezone as stored on the request.
//    There is deliberately NO fallback to the device here: it would show the
//    teacher their own clock labelled as the learner's local time. Missing or
//    unknown timezone renders "N/A" instead.
const SystemTime = ({ timeZone, deviceTime = false, className = "fw-500 text-dif-black font-14" }) => {
  const resolved = deviceTime ? deviceTimeZone() : timeZone;
  const zone = resolved && moment.tz.zone(resolved) ? resolved : null;

  const [currentTime, setCurrentTime] = useState(() => (zone ? formatTime(zone) : null));

  useEffect(() => {
    if (!zone) {
      setCurrentTime(null);
      return undefined;
    }
    setCurrentTime(formatTime(zone));
    const timer = setInterval(() => setCurrentTime(formatTime(zone)), 1000);
    return () => clearInterval(timer);
  }, [zone]);

  if (!zone) {
    return <span className={className}>N/A</span>;
  }

  return (
    <span className={className}>
      {currentTime} ({zone})
    </span>
  );
};

export default SystemTime;
